module.exports = __webpack_public_path__ + "static/media/Timer_Backing@3x.f680b46c.png";